<template lang='pug'>
  .app-header#header
    template(v-if='!isMobile')
      topbar
    template(v-else)
      #dy-promotion-banner
      promotion-banner

    .sitewide-banner.js-sign-in-banner#sign-in-banner(v-if='showSignInBanner && !currentUser')
      sign-in-banner
    .container.sitewide-banner.js-header-banner#header_banner(v-else-if='banner && currentUser')
      a.ga-tracking-sitewide-banner(v-if='banner.url' :href='banner.url' :target='!!banner["new_tab"] ? "_blank" : ""')
        img.banner(:src='banner["image-url"]')
      img.banner(v-else :src='banner["image-url"]')
    .sitewide-banner.js-dy-header-banner#dy-header-banner(v-else)

    logo-section
    .navigation-menu-anchor(v-show='stickyNavigationMenu')
    //- sticky-top allows for the navigation to be correctly padded when the scollbar is hidden as it is a selector used by the modal helpers
    .js-navigation-menu#navigation-menu(:class='{ "sticky": stickyNavigationMenu, "sticky-top": stickyNavigationMenu }' v-if='!isMobile')
      .container
        template(v-if='currentUser && currentUser.attributes && currentUser.attributes.admin')
          template(v-if='rootUrl.indexOf(generateAdminUrl(tenant)) === -1 && isProduction')
            a.h5.toggle-menu.redirect(:href='generateAdminUrl(tenant)' target='_blank') Toggle Menu
          template(v-else)
            admin-navigation
            a.h5.toggle-menu(href='#' @click.prevent='toggleMenu') Toggle Menu
        user-navigation
</template>

<script>
import { mapState } from 'vuex'
import { generateAdminUrl } from '@/modules/config/tenant'

import UserNavigation from './user-navigation.vue'
import Topbar from './topbar.vue'
import LogoSection from './logo-section.vue'
import SignInBanner from './sign-in-banner.vue'
import PromotionBanner from './promotion-banner.vue'

const AdminNavigation = () => import(
  /* webpackChunkName: 'layout-admin-navigation' */ './admin-navigation.vue'
)

export default {
  name: 'AppHeader',
  components: {
    UserNavigation,
    AdminNavigation,
    Topbar,
    LogoSection,
    SignInBanner,
    PromotionBanner
  },

  data () {
    return {
      excludedPages: ['cart', 'orders', 'users', 'rewards-boutique', 'beauty-pass', 'faqs', 'security-policy-update'],
      stickyNavigationMenu: false
    }
  },

  computed: {
    ...mapState({
      showAdminNav: state => state.layout.showAdminNav,
      currentUser: state => state.user.currentUser,
      banner: state => state.layout.sitewideBanner
    }),
    showSignInBanner () {
      const route = this.$route.path.split('/')[1]
      return !this.excludedPages.includes(route)
    },
    isMobile: () => vueSupport.isMobile,
    tenant: () => vueSupport.tenant,
    rootUrl: () => window.config.domain,
    isProduction: () => vueSupport.env === 'production'
  },

  created () {
    window.addEventListener('scroll', this.onScrollDesktop)
  },

  destroyed () {
    window.removeEventListener('scroll', this.onScrollDesktop)
  },

  methods: {
    generateAdminUrl,

    toggleMenu () {
      this.$store.commit('setShowAdminNav', !this.showAdminNav)
    },

    onScrollDesktop () {
      if (this.isMobile) {
        return
      }

      const navOffsetTop = 120
      const topbarHeight = 35
      const headerBannerHeight = $('#header_banner').height() ? $('#header_banner').height() : 0
      const sitewideBannersHeight = headerBannerHeight + $('#sign-in-banner').height()
      this.stickyNavigationMenu = window.scrollY >= navOffsetTop + sitewideBannersHeight - topbarHeight
    }
  }
}
</script>

<style lang='scss' scoped>
  .app-header {
    @include media-breakpoint-down(sm) {
      background-color: $white;
      position: fixed;
      top: 0;
      width: 100%;
      z-index: $zindex-fixed;
    }

    @include media-breakpoint-up(md) {
      padding-top: 35px;
    }
  }

  .sitewide-banner {
    max-width: 1125px;
    max-height: 45px;
    margin: auto;

    @include media-breakpoint-up(lg) {
      width: 100% !important;  //override body #header #header_banner
    }

    @include media-breakpoint-down(lg) {
      height: 100% !important;  //override body #header #header_banner
      padding: 0;
    }

    .banner {
      width: 100%;
    }
  }

  .toggle-menu {
    display: none;
    left: 10px;
    top: 6px;
    color: $black;
    padding: 5px;
    position: absolute;
    text-decoration: underline;

    @include media-breakpoint-up(xl) {
      display: inline-block;
    }
  }

  .navigation-menu-anchor {
    height: 35px;
  }

  #navigation-menu {
    box-sizing: border-box;
    height: 45px;
    position: relative;
    background: $white;
    display: block;
    width: 100%;
    z-index: $zindex-dropdown;

    @include media-breakpoint-up(lg) {
      height: auto;
    }

    > .container {
      background-color: $white;
      border-bottom: 1px solid $grey;
    }

    &.scroll-to-fixed-fixed {
      border-bottom: 1px solid $grey;

      > .container {
        border-bottom: 0;
      }
    }

    &.sticky {
      background: $white;
      border-bottom: 1px solid $grey;
      position: fixed;
      top: 35px;
      left: 0;
      right: 0;
      height: 35px;
      z-index: $zindex-sticky;

      > .container {
        border-bottom: 0;
      }
    }
  }

  #add_to_cart_notification {
    min-height: 0px !important;
    box-sizing: border-box;
    position: fixed;
    display: none;
    top: 122px;
    right: 0;
    z-index: 2000;
    width: 100%;

    .alert {
      box-sizing: border-box;
      min-height: 0px;
      position: static;
    }

    .alert-message {
      width: 100%;
      text-transform: capitalize;

      .link {
        text-decoration: underline;
      }
    }
  }
</style>
